/* eslint-disable camelcase */
import PropTypes from 'prop-types';
import React from 'react';
import {
  Button,
  Spacer,
  TranslationProvider,
} from '@resy/ui-kitchen';
import { getTranslation } from '../../../../../ui-kitchen/src/providers/TranslationProvider';

import AddOnCollection from '../AddOnCollection';
import AddOnType from '../../types/AddOn';
import CategoryRequirements from './CategoryRequirements';
import './Category.scss';
import {
  getNumItemsSelectedInCategory,
  withMultiplier,
} from '../../utils/addOnsHelpers';

class Category extends React.Component {
  static propTypes = {
    clearCategory: PropTypes.func,
    currencyCode: PropTypes.string,
    description: PropTypes.string,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        category_id: PropTypes.number,
        item_id: PropTypes.number,
        quantity: PropTypes.number,
      })
    ).isRequired,
    fulfilled: PropTypes.bool,
    // the number of items left to be selected in a category to fulfill a max_quantity
    // eg max_quantity is 8 and 6 have been selected in the category,
    // then numItemsToMax is 2
    numItemsToMax: PropTypes.number,
    maxSelected: PropTypes.bool,
    max_quantity: PropTypes.number,
    min_quantity: PropTypes.number,
    name: PropTypes.string,
    onChange: PropTypes.func,
    option_group_id: PropTypes.number,
    options: PropTypes.arrayOf(AddOnType),
    seats: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    select_per_guest: PropTypes.bool,
    sourceId: PropTypes.string,
  }

  static defaultProps = {
    clearCategory: undefined,
    currencyCode: 'USD',
    description: undefined,
    fulfilled: undefined,
    numItemsToMax: undefined,
    min_quantity: undefined,
    max_quantity: undefined,
    maxSelected: undefined,
    name: undefined,
    onChange: undefined,
    option_group_id: undefined,
    options: undefined,
    seats: undefined,
    select_per_guest: undefined,
    sourceId: undefined,
  }

  clearCategory = () => {
    const {
      clearCategory,
      option_group_id: categoryId,
    } = this.props;

    clearCategory(categoryId);
  }

  isOptional = () => {
    const { min_quantity } = this.props;

    return !Number.isInteger(min_quantity);
  }

  renderAddOns = () => {
    const {
      currencyCode,
      fulfilled,
      numItemsToMax,
      maxSelected,
      onChange,
      options: addOns,
      option_group_id,
      sourceId,
    } = this.props;

    if (!addOns?.length) {
      return null;
    }

    return (
      <AddOnCollection
        addOns={addOns}
        categoryId={option_group_id}
        currencyCode={currencyCode}
        fulfilled={fulfilled}
        max={numItemsToMax}
        maxSelected={maxSelected}
        onChange={onChange}
        sourceId={sourceId}
      />
    );
  }

  renderClear = () => {
    const { items, name, option_group_id: categoryId } = this.props;
    const numItems = getNumItemsSelectedInCategory(categoryId, items);

    if (!numItems) {
      return null;
    }

    return (
      <TranslationProvider translationKey="clear">
        <Button
          aria-label={name ? getTranslation({
            translationKey: 'clear_selected_add_ons_for_category',
            translationValues: { name },
            fallback: `Clear selected add-ons for ${name}`,
          }) : getTranslation({
            translationKey: 'clear_selected_add_ons',
            fallback: 'Clear selected add-ons',
          })}
          onClick={this.clearCategory}
          variant="link"
          sm
        >
          Clear
        </Button>
      </TranslationProvider>
    );
  }

  renderDescription = () => {
    const { description } = this.props;
    if (!description) {
      return null;
    }

    return (
      <div className="Category__description">{description}</div>
    );
  }

  renderRequirement = () => {
    const {
      fulfilled, min_quantity, max_quantity, seats, select_per_guest,
    } = this.props;
    const multiplier = select_per_guest ? seats : 1;
    const min = min_quantity && withMultiplier(multiplier, min_quantity);
    const max = max_quantity && withMultiplier(multiplier, max_quantity);

    return <CategoryRequirements fulfilled={fulfilled} num={min || max} optional={this.isOptional()} />;
  }

  renderRequirementWithClear = () => (
    <div className="Category__RequirementRow">
      {this.renderRequirement()}
      {this.renderClear()}
    </div>
  )

  renderName = () => {
    const { name } = this.props;

    if (!name) {
      return null;
    }

    return (
      <h2 className="Category__name">{name}</h2>
    );
  }

  render() {
    const { description, option_group_id } = this.props;

    return (
      <div className="Category" id={`category-${option_group_id}`}>
        <div className="Category__header-sticky">
          <Spacer height="10" />
          {this.renderName()}
          {this.renderRequirementWithClear()}
          {description ? <Spacer height="10" /> : <Spacer height="15" />}
        </div>
        {this.renderDescription()}
        {description && <Spacer height="15" />}
        {this.renderAddOns()}
      </div>
    );
  }
}

export default Category;
